import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {Box, Typography} from '@mui/material';
import '../Demo.scss';
import {ISelectItem, GroupedItem} from '../../../shared/types';
import ArrMultiSelectDropdown from '../../../components/common/arr-select-dropdown/ArrMultiSelectDropdown';
import ArrSingleSelectDropdown from '../../../components/common/arr-select-dropdown/ArrSingleSelectDropdown';
import ArrGroupedSelectDropdown from '../../../components/common/arr-select-dropdown/ArrGroupedSelectDropdown';
const options: ISelectItem[] = [
  {id: '1', name: 'Option 1'},
  {id: '2', name: 'Option 2'},
  {id: '3', name: 'Option 3', disabled: 'true'},
  {
    id: '4',
    name: 'Menu Item Lorem Ipsum Dolor Amet Sit Lorem Ipsum Dolor Amet Sit Lorem Ipsum Dolor Amet Sit Lorem Ipsum Dolor Amet End',
  },
  {id: '5', name: 'Option 5'},
  {id: '6', name: 'Option 6'},
  {id: '7', name: 'Option 7'},
  {id: '8', name: 'Option 8'},
  {id: '9', name: 'Option 9'},
  {id: '10', name: 'Option 10'},
  {id: '11', name: 'Option 11'},
  {id: '12', name: 'Option 12'},
  {id: '13', name: 'Option 13'},
  {id: '14', name: 'Option 14'},
  {id: '15', name: 'Option 15'},
  {id: '16', name: 'Option 16'},
  {id: '17', name: 'Option 17'},
  {id: '18', name: 'Option 18'},
  {id: '19', name: 'Option 19'},
  {id: '20', name: 'Option 20'},
];
const groupedOptions: GroupedItem[] = [
  {
    groupName: 'parent 1',
    items: [
      {id: 1, label: 'item 1'},
      {id: 2, label: 'item 2'},
    ],
  },
  {
    groupName: 'parent 2',
    items: [
      {id: 3, label: 'item 3'},
      {id: 4, label: 'item 4'},
    ],
  },
];

const SelectDropdown: React.FC = () => {
  const [selectedMulti, setSelectedMulti] = useState<ISelectItem[]>([]);
  const [singleValue, setSingleValue] = useState<ISelectItem | null>(null);
  const [selectedMultiWithControl, setSelectedMultiWithControl] = useState<
    ISelectItem[]
  >([]);
  const [selectedValue, setSelectedValue] = useState<string | number | null>(
    null
  );

  return (
    <Box className="select-dropdown">
      <h1>Select Dropdown</h1>
      <Typography></Typography>
      <hr />
      <Link to="/demo" className="link">
        Return
      </Link>
      <hr />
      <Box>
        <Typography className="typo-text headline3_size">
          Large Default
        </Typography>
        <div style={{display: 'flex', gap: '1rem', marginTop: '1rem'}}>
          <ArrMultiSelectDropdown
            dropdownLabel="Select Multiple"
            dropdownItems={options}
            selectedValues={selectedMulti}
            onSelectionChange={setSelectedMulti}
            multiple
            searchable
            withSelectAll={false}
            checkboxDataTestId="select-dropdown-demo-large-select-multiple-checkbox"
          />

          <ArrMultiSelectDropdown
            dropdownLabel="Disabled Example"
            dropdownItems={options}
            multiple
            selectedValues={[{id: '1', name: 'Option 1'}]}
            onSelectionChange={() => {}}
            disabled
            checkboxDataTestId="select-dropdown-demo-large-disabled-checkbox"
          />

          <ArrMultiSelectDropdown
            dropdownLabel="Error"
            dropdownItems={[
              {id: '1', name: 'Option 1'},
              {id: '2', name: 'Option 2'},
            ]}
            multiple
            selectedValues={[]}
            onSelectionChange={setSelectedMulti}
            error
            checkboxDataTestId="select-dropdown-demo-large-error-checkbox"
          />
        </div>
      </Box>
      <Box>
        <div style={{display: 'flex', gap: '1rem', marginTop: '1rem'}}>
          <ArrSingleSelectDropdown
            dropdownLabel="Select Single"
            dropdownItems={options}
            selectedValues={singleValue}
            onSelectionChange={setSingleValue}
            searchable
            customWidth={20}
            clearSelection={true}
            dataTestId="asd-filter-panel-select-single-dropdown"
          />
          <ArrMultiSelectDropdown
            dropdownLabel="Select Multiple with control"
            dropdownItems={options}
            selectedValues={selectedMultiWithControl}
            onSelectionChange={setSelectedMultiWithControl}
            multiple
            searchable
            withControls
            checkboxDataTestId="select-dropdown-demo-large-with-control-checkbox"
            onClearAll={() => console.log(' Clear All triggered')}
            onApply={(values) => console.log('Apply clicked with:', values)}
            dataTestId="asd-selectmultiple-withcontrol"
          />
        </div>
      </Box>
      <Box>
        <br />
        <Typography className="typo-text headline3_size">Medium</Typography>
        <div style={{display: 'flex', gap: '1rem', marginTop: '1rem'}}>
          <ArrSingleSelectDropdown
            dropdownLabel="Select Single"
            dropdownItems={options}
            selectedValues={singleValue}
            onSelectionChange={setSingleValue}
            sizeVariant="medium"
            dataTestId="asd-filter-panel-select-single-med"
          />
          <ArrMultiSelectDropdown
            dropdownLabel="Select Multiple"
            dropdownItems={options}
            selectedValues={selectedMulti}
            onSelectionChange={setSelectedMulti}
            multiple
            searchable
            sizeVariant="medium"
            checkboxDataTestId="select-dropdown-demo-medium-select-multiple-checkbox"
            formControlRestProps={{
              required: true,
            }}
            dataTestId="msd-select-multiple-medium"
          />
          <ArrGroupedSelectDropdown
            dropdownLabel="Grouped Select"
            groupedItems={groupedOptions}
            selectedValue={selectedValue}
            sizeVariant="medium"
            onSelectionChange={(value) => {
              console.log('Selected value:', value);
              setSelectedValue(value);
            }}
            dataTestId="demo"
            searchable
          />

          <ArrMultiSelectDropdown
            dropdownLabel="Disabled Example"
            dropdownItems={options}
            multiple
            selectedValues={[]}
            onSelectionChange={() => {}}
            disabled
            sizeVariant="medium"
            checkboxDataTestId="select-dropdown-demo-medium-disabled-checkbox"
          />
          <ArrMultiSelectDropdown
            dropdownLabel="Error"
            dropdownItems={options}
            multiple
            selectedValues={[]}
            onSelectionChange={setSelectedMulti}
            error
            sizeVariant="medium"
            checkboxDataTestId="select-dropdown-demo-medium-error-checkbox"
          />
        </div>
      </Box>
      <Box>
        <br />
        <Typography className="typo-text headline3_size">Small</Typography>
        <div style={{display: 'flex', gap: '1rem', marginTop: '1rem'}}>
          <ArrSingleSelectDropdown
            dropdownLabel="Select Single"
            dropdownItems={options}
            selectedValues={singleValue}
            onSelectionChange={setSingleValue}
            sizeVariant="small"
            dataTestId="asd-filter-panel-select-single-small"
          />
          <ArrMultiSelectDropdown
            dropdownLabel="Select Multiple"
            dropdownItems={options}
            selectedValues={selectedMulti}
            onSelectionChange={setSelectedMulti}
            multiple
            searchable
            sizeVariant="small"
            checkboxDataTestId="select-dropdown-demo-small-select-multiple-checkbox"
          />

          <ArrMultiSelectDropdown
            dropdownLabel="Disabled Example"
            dropdownItems={options}
            multiple
            selectedValues={[]}
            onSelectionChange={() => {}}
            disabled
            sizeVariant="small"
            checkboxDataTestId="select-dropdown-demo-small-disabled-checkbox"
          />

          <ArrMultiSelectDropdown
            dropdownLabel="Error"
            dropdownItems={options}
            multiple
            selectedValues={[]}
            onSelectionChange={setSelectedMulti}
            error
            sizeVariant="small"
            checkboxDataTestId="select-dropdown-demo-small-error-checkbox"
          />
        </div>
      </Box>
    </Box>
  );
};

export default SelectDropdown;
